import React, { useState } from 'react';
import Button from './ui/Button';

function MarketingSignup() {
  const [email, setEmail] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requestBody = {
      email,
    };

    const apiUrl = process.env.REACT_APP_APIUrl;
    const clientId = process.env.REACT_APP_ClientId;

    try {
      const response = await fetch(`${apiUrl}/EmailSignUp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ClientId: clientId,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        alert(`Thank you for subscribing, ${email}!`);
        setEmail('');
      } else {
        alert('Failed to Subscribe. You may already be a subscriber!');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again.');
    }
  };

  return (
    <aside className="rounded-2xl border border-optical-100 bg-gradient-to-br from-optical-50/80 to-white p-8 shadow-card md:p-10" aria-labelledby="newsletter-heading">
      <h3 id="newsletter-heading" className="font-display text-xl font-semibold text-slate-900">
        Join our newsletter
      </h3>
      <p className="mt-2 text-sm text-slate-600">
        Special offers, event news, and eyewear tips — no spam.
      </p>
      <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
        <div>
          <label htmlFor="newsletter-email" className="sr-only">
            Email address for newsletter
          </label>
          <input
            id="newsletter-email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-slate-200 px-4 py-3 text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-optical-400 focus:outline-none focus:ring-2 focus:ring-optical-500/30"
            required
            autoComplete="email"
          />
        </div>
        <Button variant="primary" type="submit" className="w-full sm:w-auto">
          Subscribe
        </Button>
      </form>
    </aside>
  );
}

export default MarketingSignup;
